import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Grid, Paper } from "@material-ui/core";
import useFetch from "../services/employeeService";
import { useFormik } from "formik";
import * as yup from "yup";
import Controls from "../components/controls/Controls";
import TextField from "@material-ui/core/TextField";
import DatePicker from "@material-ui/pickers/DatePicker";
import { useForm, Form } from "../components/useForm";
import * as employeeService from "../services/employeeService";
import * as data from "../services/data";

// const getYear = require("date-fns/getYear");
// const getMonth = require("date-fns/getMonth");

const validationSchema = yup.object({
  cropId: yup.number("Select crop").required("Crop is required"),
  landExtent: yup
    .number("Enter land extent")
    .required("Land extent is required"),
  expectedHarvest: yup
    .number("Enter expected harvest")
    .required("Expected harvest is required"),
  yearAndMonth: yup
    .date("Select year and month")
    .required("Year and month is required"),
});

export default function CropForm(props) {
  const { id: farmerId } = useParams();
  const { addOrEdit, recordForEdit } = props;
  const [crop, setCrop] = useState(null);
  // const crops = [
  //   { title: "Photato", id: 1 },
  //   { title: "Beans", id: "2" },
  // ];
  const [{ data: crops }] = useFetch("get", "/crop", null);
  const formik = useFormik({
    initialValues: {
      // id: 0,
      cropId: "",
      farmerId,
      landExtent: "",
      expectedHarvest: "",
      yearAndMonth: new Date(),
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const updateData = {
        cropId: values.cropId,
        farmerId: values.farmerId,
        landExtent: values.landExtent,
        expectedHarvest: values.expectedHarvest,
        yearAndMonth: values.yearAndMonth,
      };

      let id;
      alert(JSON.stringify(values, null, 2));
      if (values.id) addOrEdit(updateData, (id = values.id), formik.resetForm);
      if (!values.id) addOrEdit(values, (id = null), formik.resetForm);
    },
  });
  // const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
  //   useForm(formik.initialFValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (validate()) {
    //   addOrEdit(values, resetForm);
    // }
  };

  useEffect(() => {
    if (recordForEdit != null) {
      setCrop(recordForEdit.crop);
      // formik.initialValues.cropId = recordForEdit.cropId;
      formik.setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit]);

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Grid container>
        <Grid item xs={12} md={8}>
          <Controls.AutoComplete
            id="cropId"
            label="Crop"
            options={crops}
            // defaultValue={crops.find((e) => e.id === formik.values.cropId)}
            // value={crops.find((e) => e.id === formik.values.cropId)}
            getOptionLabel={(option) => option.name}
            value={crop}
            // inputValue={crops.find((e) => e.id === formik.initialValues.cropId)}
            // onInputChange={(e, value) => {
            //   console.log(value);
            //   formik.setFieldValue(
            //     "cropId",
            //     value !== null ? value : formik.values.cropId
            //   );
            // }}
            getOptionSelected={(option, value) => option.id === value.id}
            onChange={(e, value) => {
              setCrop(value);
              formik.setFieldValue(
                "cropId",
                value !== null ? value.id : formik.initialValues.cropId
              );
            }}
            error={formik.touched.cropId && Boolean(formik.errors.cropId)}
            helperText={formik.touched.cropId && formik.errors.cropId}
          />
          <Controls.Input
            name="landExtent"
            label="Land Extent in Acres"
            value={formik.values.landExtent}
            onChange={formik.handleChange}
            error={
              formik.touched.landExtent && Boolean(formik.errors.landExtent)
            }
            helperText={formik.touched.landExtent && formik.errors.landExtent}
          />

          <Controls.Input
            label="Expected Harvest in kg"
            name="expectedHarvest"
            value={formik.values.expectedHarvest}
            onChange={formik.handleChange}
            error={
              formik.touched.expectedHarvest &&
              Boolean(formik.errors.expectedHarvest)
            }
            helperText={
              formik.touched.expectedHarvest && formik.errors.expectedHarvest
            }
          />
          <Controls.MonthYearPicker
            variant="inline"
            name="yearAndMonth"
            label="Year and Month"
            value={formik.values.yearAndMonth}
            onChange={formik.handleChange}
            error={
              formik.touched.yearAndMonth && Boolean(formik.errors.yearAndMonth)
            }
            helperText={
              formik.touched.yearAndMonth && formik.errors.yearAndMonth
            }
          />
          <div>
            <Controls.Button type="submit" text="Submit" />
            <Controls.Button
              text="Reset"
              color="default"
              onClick={() => {
                formik.resetForm();
              }}
            />
          </div>
        </Grid>
        {/* <Grid item xs={12} md={6}>
          
        </Grid> */}
      </Grid>
    </Form>
  );
}
